// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__QLan8","section-1":"style_section-1__3bLp5","content":"style_content__-uP6E","section-2":"style_section-2__QwNZX","section":"style_section__22KEm"};